module.exports = __webpack_public_path__ + "static/media/7.d6ef9217.mp4";